import React, { Component } from 'react';
import {Ripple} from 'react-preloaders';
import firebase from "../firebase/config";
import './styles/player.css';

export default class Player extends Component {
  constructor(props){
    super(props);
    console.log(props.match.params.id);
    this.state = {
      id: props.match.params.id,
      data: {}, 
      items: [],
      loading: true,
      videoID: ''
    }
  }

  componentDidMount(){
    firebase.db.collection("ucl-highlights").doc(this.state.id).get()
    .then(res => {
      console.log('data', res.data());
      this.setState({
        data: res.data()
      });
      this.setState({
        items: res.data().matches.split('\n'),
        loading: false
      });
      console.log(this.state.items);
    })
    .catch(err => {
      console.log(err)
    });
  }

    render() {
        return (
          <div className="row" id="main">
              <div className="col s12 l8">
                <div className="video-container">
                  <iframe src={this.state.data.frame} allowFullScreen></iframe>
                </div>
                <a style={{position: 'fixed', bottom: 0, right: 0}} href={this.state.data.frame} target="_blank">&#128279;</a>
              </div>
              <div className="col s12 l4 center-align">
                <div className="card card-detail">
                  <p className="title-player"><b>{this.state.data.title}</b></p>
                  <div className="divider"></div>
                  <p>{this.state.data.date}</p>
                  <p>Matches:</p>
                  {this.state.items.map((w, index) => {
                    return (
                      <div>
                        <span key={index}>{w}</span>
                        <br></br>
                      </div>
                    )
                  })}
                </div>
              </div>
              <Ripple customLoading={this.state.loading}  background="#000b24" color="#FFFFFF"/>
          </div>
        )
    }
}